// @flow
import React, { Fragment, type Node } from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';
import ratioUtils from 'Components/utils/ratios/ratios.utils';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import Image from 'Components/frameworks/image/Image.jsx';

import { themes } from './AdditionItemImage.themes';

type AdditionItemImageProps = {
  image?: {
    alt?: string,
    src: string,
  },
  label?: string,
  ratioKey?: MediaRatios,
  symbol?: Node,
  theme?: string,
};

export function AdditionItemImage(props: AdditionItemImageProps) {
  const { image = {}, label, symbol, ratioKey = ratioUtils.XL, theme = 'default' } = props;

  if (!image.src) return null;

  const { thItemImage, thItemLabel, thItemLabelIcon, thItemLabelIconSize } = themes[theme];

  return (
    <Fragment>
      <div className={classnames('image-responsive-cell', thItemImage)}>
        <Image altMsg={image.alt} imageUrl={image.src} ratioKey={ratioKey} />
        {symbol}
      </div>
      {!!label && (
        <div className={thItemLabel} data-testid="AdditionItemImage-label">
          <Icon className={thItemLabelIcon} name={ICONS.CHECK} width={thItemLabelIconSize} />
          {label}
        </div>
      )}
    </Fragment>
  );
}
